import React, { Component } from "react";
import _ from "i18n";
import { ArrowLeft } from "./Icons";

class TTPTab extends Component {
  selectTab = (ev, tabId) => {
    ev.preventDefault();
    this.props.selectTab(tabId);
  };

  render() {
    const { tabs, activeTab } = this.props;

    return (
      <div className="ttp-tab-selector">
        <nav>
          <button
            onClick={() =>
              this.props.arrowLeft ? this.props.handleActivateArrowLeft() : ""
            }
            style={{
              width: "52px",
              cursor: this.props.arrowLeft ? "" : "not-allowed",
              background: this.props.arrowLeft ? "" : "rgb(241, 242, 244)"
            }}
          >
            <ArrowLeft />
          </button>
          {tabs.map(tab => {
            return (
              <button
                key={tab.id}
                href="#"
                className={`${activeTab === tab.id ? "active" : ""}`}
                onClick={ev => this.selectTab(ev, tab.id)}
                style={{
                  width: tab.label && tab.label.length > 18 ? "250px" : ""
                }}
              >
                {_(tab.label)}
              </button>
            );
          })}
          <button
            onClick={() =>
              this.props.arrowRight ? this.props.handleActivateArrowRight() : ""
            }
            style={{
              width: "52px",
              transform: "rotate(180deg)",
              cursor: this.props.arrowRight ? "" : "not-allowed",
              background: this.props.arrowRight ? "" : "rgb(241, 242, 244)"
            }}
          >
            <ArrowLeft />
          </button>
        </nav>
      </div>
    );
  }
}

export default TTPTab;



// WEBPACK FOOTER //
// ./src/components/Common/TTPTab.js